<template>
    <el-col>
        <common-table :data="userRoleList">
            <!-- <common-table-column label="序号" prop="roleId"></common-table-column> -->
            <common-table-column label="角色名称" prop="roleName"></common-table-column>
            <common-table-column label="说明" prop="remark"></common-table-column>
            <common-table-column label="维护人" prop="name"></common-table-column>
            <common-table-column label="创建日期" prop="rowTime"></common-table-column>
            <el-table-column label="管理" prop="temp" align="center">
                <template slot-scope="scope">
                    <el-button type="text" @click="onItemEdit(scope.row)">编辑</el-button>
                    <el-button type="text" @click="onItemDelete(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </common-table>
        <create-role-dialog :visible.sync="editRoleDialogVisible" :form-data="tempItemInfo"/>
    </el-col>
</template>

<script>
    import CommonTable from "@/components/CommonTable";
    import CommonTableColumn from "@/components/CommonTableColumn";
    import {mapGetters} from "vuex";
    import CreateRoleDialog from "@/views/System/Role/CreateRoleDialog";
	// import {dealDeleteOperation} from "@/utils/tools";
	import {Message, MessageBox} from "element-ui";

    export default {
        name: "RoleTable",
        components: {CreateRoleDialog, CommonTableColumn, CommonTable},
        computed: {...mapGetters(['userRoleList'])},
        created() {
            this.$store.dispatch('role/userRoleList');
        },
        data() {
            return {list: [], editRoleDialogVisible: false, tempItemInfo: {}}
        },
        methods: {
            async onItemEdit(item) {
                console.log(item);
                this.tempItemInfo = item;
                this.editRoleDialogVisible = true;
            },
            async onItemDelete(item) {
                console.log(item);
								MessageBox.confirm('即将执行删除操作, 是否继续?', '提示', {
										confirmButtonText: '确定',
										cancelButtonText: '取消',
										type: 'warning'
								}).then(async () => {
										return this.$store.dispatch('role/userRoleDelete', {roleId: item.roleId});
								}).then(async () => {
										Message.success('删除成功!');
										await this.$store.dispatch('role/userRoleList');

								});
            }
        }
    }
</script>

<style scoped>

</style>